<template>
  <div class="row">
    <div class="col-xs-12">
      <h1 class="page-header">{{ title }}</h1>
      <div class="row">
        <div class="col-xs-12">
          <div class="row">
            <div class="col-xs-12 col-sm-9">
              <div class="form-group">
                <v-select v-model="escalaId" @input="loadEscala" :placeholder="escalaLabel" :options="escalas"
                  :reduce="u => u.codigo" :selectOnTab="true">
                </v-select>
              </div>
            </div>
            <div class="col-xs-12 col-sm-3">
              <button @click.prevent="devolver" :disabled="acaoIndisponivel" title="Devolver para a seção corrigir!"
                class="btn btn-danger btn-sm">
                <font-awesome-icon :icon="'undo'"></font-awesome-icon>
                Devolver
              </button>
              <button @click.prevent="publicar" :disabled="acaoIndisponivel" title="Publicar no portal"
                class="btn btn-primary btn-sm">
                <font-awesome-icon :icon="'file-import'"></font-awesome-icon>
                Publicar
              </button>
            </div>
          </div>
        </div>
        <div class="col-xs-12 col-sm-12">

          <data-table-public ref="escalas" title="lista de dados" :has-auth="false" :api-mode="false" :data="escalaItens"
            :show-empty="true" :fields="datatable.columns">
            <template slot="columncustom" slot-scope="props">
              <section>
                <article v-for="({ entrada, saida, dias }, index) in props.rowData
                  .periodos" :key="index">
                  <label>
                    <div v-if="entrada !== ''">
                      {{ entrada }}
                    </div>
                    <div v-else>
                      <font-awesome-icon :icon="'arrow-alt-circle-right'"></font-awesome-icon>
                    </div>
                    <div v-if="entrada !== '' && saida !== ''">-</div>
                    <div v-if="saida !== ''">
                      {{ saida }}
                    </div>
                    <div v-else>
                      <font-awesome-icon :icon="'arrow-alt-circle-right'"></font-awesome-icon>
                    </div>
                  </label>
                  <span v-for="(dia, index) in dias" :key="index">
                    {{ dia }}
                  </span>
                </article>
              </section>
            </template>
          </data-table-public>

          <footer>
            <label>Observação</label>
            <div class="well">
              {{ observacao }}
            </div>
          </footer>

        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { request } from '@/request'
import DataTablePublic from '@/components/common/DataTablePublic'

export default {
  inject: ["showConfirm"],
  data() {
    return {
      title: 'Publicar escalas',
      datatable: {
        columnID: 'id',
        columns: [
          {
            name: 'colaborador_nome',
            title: 'Colaboradores',
            dataClass: 'align-middle text-capitalize',
            filterable: true
          },
          {
            name: 'colaborador_cargo',
            title: 'Cargo',
            dataClass: 'align-middle text-capitalize',
            filterable: true
          },
          {
            name: 'plantao_total',
            title: 'Qtde Plantoes',
            titleClass: 'text-center',
            dataClass: 'align-middle text-center'
          },
          {
            name: '__slot:column',
            title: 'Horários | Dias'
          }
        ]
      },
      escalaLabel: "Selecione a escala",
      escalaId: null,
      escalas: [],
      escalaItens: [],
      observacao: null
    }
  },
  components: {
    DataTablePublic
  },
  beforeCreate() {
    if (!this.$store.state.isLogged) {
      this.$router.push('/login')
    }
  },
  created() {
    this.loadEscalas()
  },
  computed: {
    acaoIndisponivel() {
      return this.escalaId === null
    }
  },
  methods: {
    loadEscalas() {
      this.uorLabel = 'Carregando as escalas...'

      request.get('escala/listar-escala-publicacao')
        .then(({ data }) => {
          this.escalas = data.map(({ id: codigo, uor_sigla, referencia_descricao }) => {
            return { codigo, label: `${referencia_descricao} | ${uor_sigla}` }
          })
        })
        .catch(e => {
          console.log(e)
        })
    },
    loadEscala() {
      let { escalaId } = this
      if (escalaId == null) {
        this.escalas = []
        return
      }

      request
        .post('escala/listar-disponiveis-publicacao', { id: escalaId })
        .then(response => {
          this.escalaItens = response.data
          this.loadObservacao()
        })
        .catch(e => {
          console.log(e)
        })
    },
    loadObservacao() {
      this.observacao = "Carregando..."

      request
        .get(`escala/observacao?id=${this.escalaId}`)
        .then(response => {
          this.observacao = response.data
        })
        .catch(e => {
          console.log(e)
        })
    },
    publicar() {
      this.alert({
        url: 'escala/publicar',
        successMessage: 'Escala foi publicada com sucesso!',
        errorMessage:
          'Houve uma falha ao tentar publicar a escala, Tente novamente daqui alguns minutos!',
        confirmMessage: 'Deseja realmente publicar está escala?'
      })
    },
    devolver() {
      this.alert({
        url: 'escala/devolver',
        successMessage: 'Escala foi devolvida com sucesso!',
        errorMessage:
          'Houve uma falha ao tentar devolver a escala, Tente novamente daqui alguns minutos!',
        confirmMessage: 'Deseja realmente devolver está escala?'
      })
    },
    alert({ url, successMessage, errorMessage, confirmMessage }) {
      if (this.escalaId === null) return

      const config = {
        title: 'Alerta',
        question: true,
        yes: () => {
          request.post(url, { id: this.escalaId })
            .then(() => {
              this.$toastr.s(successMessage)
              this.reset()
            }).catch(error => {
              this.escala = null
              this.$toastr.e(errorMessage)
              this.escalas = []
              console.log(error.response)
            })
        }
      }
      this.showConfirm(confirmMessage, config)
    },
    reset() {
      this.escalaId = null,
      this.observacao = null
      this.escalaItens = []
      this.loadEscalas()
    }
  }
}
</script>

<style scoped="">
section {
  display: flex;
  flex-direction: column;
}

article {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
}

article:not(:first-child) {
  border-top: solid 1px #ccc;
}

article label {
  color: #3c763d;
  background-color: #dff0d8;
  border-color: #d6e9c6;
  border-radius: 4px;
  border: 1px solid transparent;
  padding: 0px 5px;
  font-size: 11px;
  font-weight: 600;
  margin: 0px;
  white-space: nowrap;
  width: 78px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
}

article label div:first-child i {
  margin-left: 10px;
}

article label div:last-child i {
  margin-right: 10px;
}

article span {
  background-color: white;
  border-color: #d6e9c6;
  border: 1px solid transparent;
  padding: 0px 0px 0px 5px;
  font-size: 11px;
  font-weight: 500;
}

footer label {
  width: 100%;
}

footer div {
  min-height: 100px;
}
</style>

<style>
.text-center {
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/views/admin/escalas/Publicar.vue